var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBaseButton,{class:[
    'items-center justify-between flex flex-row gap-1',
    'outline-none bg-transparent',
    'group',
    {
      'min-h-14': _vm.minHeight === 14,
      'min-h': _vm.minHeight === 0,
    },
  ],attrs:{"role":"switch","aria-checked":`${_vm.value}`,"aria-disabled":`${_vm.disabled || _vm.isLoading}`,"disabled":_vm.disabled || _vm.isLoading,"type":"button","data-testid":_setup.props.testId},on:{"click":function($event){return _vm.$emit('click')},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.$emit('click')}],"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}}},[_vm._t("default"),_vm._v(" "),(_vm.isLoading)?_c(_setup.OzIndeterminateSpinner,{staticClass:"mx-3",attrs:{"size":24,"dark-mode":_vm.darkMode}}):_c('div',{class:[
      'box-border',
      'h-6',
      'w-12',
      'p-0.5',
      'rounded-2.5xl',
      'outline-none',
      'ring-offset-2',
      // Focus ring
      'group-focus-visible:ring-2',
      // Focus ring color
      {
        'ring-grape-500': _vm.darkMode === false,
        'ring-canary-500': _vm.darkMode === true,
        'ring-grape-500 dark:ring-canary-500': _vm.darkMode === 'auto',
      },
      // Focus ring offset color
      {
        // See `OzContainedButton`.
        'ring-offset-light-ui-100': _vm.darkMode === false,
        'ring-offset-dark-ui-100': _vm.darkMode === true,
        'ring-offset-light-ui-100 dark:ring-offset-dark-ui-100': _vm.darkMode === 'auto',
      },
      _vm.disabled &&
        _vm.value && {
          'bg-grape-500 bg-opacity-50': _vm.darkMode === false,
          'bg-canary-500 bg-opacity-35': _vm.darkMode === true,
          'bg-grape-500 bg-opacity-50 dark:bg-canary-500 dark:bg-opacity-35': _vm.darkMode === 'auto',
        },
      _vm.disabled &&
        !_vm.value && {
          'bg-grey-200': _vm.darkMode === false,
          'bg-grey-700': _vm.darkMode === true,
          'bg-grey-200 dark:bg-grey-700': _vm.darkMode === 'auto',
        },
      !_vm.disabled &&
        _vm.value && {
          'bg-grape-500 hover-hover:hover:bg-opacity-90': _vm.darkMode === false,
          'bg-canary-500 hover-hover:hover:bg-canary-600': _vm.darkMode === true,
          'bg-grape-500 hover-hover:hover:bg-opacity-90 dark:bg-canary-500 hover-hover:dark:hover:bg-canary-600':
            _vm.darkMode === 'auto',
        },
      !_vm.disabled &&
        !_vm.value && {
          'bg-grey-300 hover-hover:hover:bg-grey-200': _vm.darkMode === false,
          'bg-grey-600 hover-hover:hover:bg-grey-500': _vm.darkMode === true,
          'bg-grey-300 hover-hover:hover:bg-grey-200 dark:bg-grey-600 hover-hover:dark:hover:bg-grey-500':
            _vm.darkMode === 'auto',
        },
    ]},[_c('div',{class:[
        'h-5',
        'w-5',
        'rounded-full',
        'transition-margin',
        'motion-reduce:transition-none',
        'duration-250',
        _vm.value ? 'ms-6' : 'me-6',
        _vm.disabled &&
          _vm.value && {
            'bg-grey-50': _vm.darkMode === false,
            'bg-grey-900': _vm.darkMode === true,
            'bg-grey-50 dark:bg-grey-900': _vm.darkMode === 'auto',
          },
        _vm.disabled &&
          !_vm.value && {
            'bg-grey-100': _vm.darkMode === false,
            'bg-grey-800': _vm.darkMode === true,
            'bg-grey-100 dark:bg-grey-800': _vm.darkMode === 'auto',
          },
        !_vm.disabled && {
          'bg-light-ui-100': _vm.darkMode === false,
          'bg-dark-ui-100': _vm.darkMode === true,
          'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
        },
      ]})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }